export default "__VITE_ASSET__DpR4zWhg__"